const getLeaseSlug = isLeased => {
  return isLeased ? 'kiraye' : 'alqi-satqi';
};

export default getLeaseSlug;
